<template>
    <component
        :is="resolved"
        :payload="payload"
        :view-config="viewConfig"
        @update:view-config="$emit('update:view-config', $event)"
    />
</template>

<script setup>
import { computed } from 'vue'
import ChatCompareChartCard from './ChatCompareChartCard.vue'
import ChatMarketChartCard from './ChatMarketChartCard.vue'
import ChatBrandsTableCard from './ChatBrandsTableCard.vue'
import ChatRegionsCard from './ChatRegionsCard.vue'
import ChatForecastCard from './ChatForecastCard.vue'

const props = defineProps({
    cardType: { type: String, required: true },
    payload: { type: Object, required: true },
    viewConfig: { type: Object, default: null },
})

defineEmits(['update:view-config'])

const map = {
    'compare-chart': ChatCompareChartCard,
    'market-chart': ChatMarketChartCard,
    'brands-table': ChatBrandsTableCard,
    regions: ChatRegionsCard,
    forecast: ChatForecastCard,
}

const resolved = computed(() => map[props.cardType] || null)
</script>
